import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { RolodexEntryType } from 'types'

export const useAssetHistoryData = (unitID: string | undefined) => {
  const {
    millPlans,
    assetModels,
    isLoading,
    hasEverLoaded,
    forceRefresh: refreshData,
  } = useRolodexEntries(
    !unitID
      ? undefined
      : {
          type: [RolodexEntryType.ASSET_MODEL, RolodexEntryType.MILL_PLAN],
          tags: { unit: unitID },
        }
  )
  return useMemo(() => {
    return {
      assetModels,
      millPlans,
      isLoading,
      hasEverLoaded,
      refreshData,
    }
  }, [assetModels, millPlans, refreshData, isLoading, hasEverLoaded])
}
